/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FinnairGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  UNSPECIFIED = 'UNSPECIFIED',
  UNKNOWN = 'UNKNOWN'
}

